<dx-scroll-view data-testid="voucher-scroll-view">
  <dx-load-panel
    data-testid="voucher-load-panel"
    [visible]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    shadingColor="rgba(0,0,0,0.4)">
  </dx-load-panel>
  <form #formElement (submit)="onSubmit($event)">
    <dx-form
      data-testid="form"
      id="form"
      class="cards-wide"
      [formData]="voucherData"
      [items]="formItems"
      [colCount]="2"
      [showValidationSummary]="true"
      validationGroup="formGroup"
      (onContentReady)="onFormContentReady($event)">
      <div *dxTemplate="let section of 'fileUploadTemplate'">
        <app-file-upload
          data-testid="voucher-file-upload"
          labelText=""
          [selectButtonText]="isEditable ? 'Browse or drop files here' : 'Browse or drop files here *'"
          [existingFileUrls]="isEditable ? (task?.parentUrls ?? []) : []"
          (onFileRemoveEventEmitter)="onFileRemove($event)"
          (onFileUploadEventEmitter)="onFileUpload($event)">
        </app-file-upload>
      </div>
    </dx-form>
  </form>
</dx-scroll-view>



